import { PackageVersionResolutionError, resolvePackageVersion } from "./package-version.js";

const SERVER_PACKAGE_NAME = "@appostle/server";
// In the single-package release model the daemon ships inside
// `appostle-installer`, so its package.json supplies the version.
const INSTALLER_PACKAGE_NAME = "appostle-installer";

export class DaemonVersionResolutionError extends PackageVersionResolutionError {}

export function resolveDaemonVersion(moduleUrl: string = import.meta.url): string {
  for (const packageName of [SERVER_PACKAGE_NAME, INSTALLER_PACKAGE_NAME]) {
    try {
      return resolvePackageVersion({ moduleUrl, packageName });
    } catch (error) {
      if (error instanceof PackageVersionResolutionError) {
        continue;
      }
      throw error;
    }
  }

  throw new DaemonVersionResolutionError({
    moduleUrl,
    packageName: SERVER_PACKAGE_NAME,
  });
}
